import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c(VMain,[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("XFACT - AUTOMATIZACION DEL ALMAZEN - MATERIALS VILAREGUT SL")]),_c('router-view')],1),_c('alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }